<template>
  <div>
    <div class="row">
      <h6>{{ crypto.crypto }}</h6>
    </div>
    <div class="row">
      <div class="alert alert-danger" style="margin-bottom: 35px">
        <i class="fa fa-warning"></i>
        {{ txt.attention }}
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 text-center">
        <qrcode-vue :value="crypto.address" :size="250" class="my-3 qr-code" level="H"/>
      </div>
      <div class="col-md-8">
        <table class="table table-bordered mt-2">
          <tr>
            <td>
              <b>{{ $t('address') }}</b>
            </td>
            <td v-on:click="$copyToClipboard(crypto.address)" >
              <span>{{ crypto.address }}</span>
            </td>
          </tr>
          <tr v-if="crypto.tag">
            <td>
              <b> {{ $t('destinationtag') }}</b>
            </td>
            <td>{{ crypto.tag }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ txt.depositminimum }}</b>
            </td>
            <td>{{ crypto.deposit_minimum }}</td>
          </tr>
<!--          <tr>-->
<!--            <td>-->
<!--              <b>{{ $t('paysfixedfee') }}</b>-->
<!--            </td>-->
<!--            <td>{{ crypto.deposit_fixed_fee }}</td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td>-->
<!--              <b>{{ $t('variablefee') }}</b>-->
<!--            </td>-->
<!--            <td>{{ crypto.deposit_var_fee }}</td>-->
<!--          </tr>-->
        </table>

      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center" style="margin-top: 25px">
        <small>
          {{ txt.note }}
        </small>
      </div>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "cryptoMethod",
  components: {QrcodeVue},
  data() {
    return {
      txt: {
        depositminimum: this.$t('depositminimum'),
        fixedfee: this.$t('paysfixedfee'),
        variablefee: this.$t('variablefee'),
        details: this.$t('detailstxt'),
        options: this.$t('optionstxt'),
        note: this.$t('conversionnote'),
        attention: this.$t('attentionnote')
      }
    }
  },
  props: {
    crypto: {type: Object, defaut: []},
  },
  methods: {
  }
}
</script>
<style scoped>

</style>
